import {Box, Center, Flex, Image, Text} from '@chakra-ui/react'
import VolumeIcon from '@assets/svgs/revise/volume.svg'
import {Progress} from 'antd'
import reviseRequest from '@apis/revise'
import {Fragment, useEffect, useState} from 'react'
import useExamRoom from './useExamRoom'
import {useDispatch, useSelector} from 'react-redux'
import {updateIsShowHeaderBtn} from '@redux/revise/revise'
import GlobalMic3 from '@components/GlobalMic3'

const Exercise2 = () => {
  const {currentQuestion} = useSelector((state: any) => state.revise)
  const {handlePlayAudio, handlePauseAudio} = useExamRoom()
  const [speechData, setSpeechData] = useState<any>()
  const [totalRecord, setTotalRecord] = useState<number>(0)
  const dispatch = useDispatch()

  useEffect(() => {
    setTimeout(() => {
      handlePlayAudio(currentQuestion?.data.audio)
    }, 1500)
  }, [currentQuestion])

  useEffect(() => {
    if (speechData?.total_score >= 0.6) {
      dispatch(updateIsShowHeaderBtn(true))
    }
    if (speechData?.total_score < 0.6 && totalRecord >= 4) {
      dispatch(updateIsShowHeaderBtn(true))
    }
  }, [speechData])

  const getTotalScore = (score: number) => {
    return Math.round(score * 100)
  }

  const getColorSpeechCheck = (score: number) => {
    if (score >= 0.745) return '#45BB66'
    if (score >= 0.5) return '#FFCD00'
    return '#E55856'
  }

  const getSpeechCheck = async (bold: any) => {
    let file = new File([bold], 'audio.wav', {type: 'audio/wav'})
    const formData = new FormData()
    formData.append('audio-file', file)
    formData.append('text-refs', currentQuestion?.data.sentence_en)
    const res = await reviseRequest.getSpeechCheck(formData)
    if (res?.status === 200) {
      setSpeechData(res.data.data)
      if (res.data.data) setTotalRecord((pre: number) => pre + 1)
    }
  }

  const handleStartRecording = () => {
    handlePauseAudio()
  }

  return (
    <Box className="container-xl" mt={'60px'}>
      <Flex flexDirection={'column'}>
        <Box borderRadius={'24px'} bg={'white'}>
          <Box p={{base: '30px 16px 16px 16px', md: '40px 100px 100px 100px'}}>
            <Flex flexDirection={'column'} gap={'24px'} alignItems={'center'}>
              <Text
                color={'#8C8C8C'}
                fontSize={'16px'}
                textTransform={'uppercase'}
                align={'center'}>
                {currentQuestion?.data.title}
              </Text>
              <Progress
                type="circle"
                percent={getTotalScore(speechData?.total_score)}
                size={100}
                strokeColor={getColorSpeechCheck(speechData?.total_score)}
                format={() => (
                  <Text
                    color={
                      speechData
                        ? getColorSpeechCheck(speechData?.total_score)
                        : '#BFBFBF40'
                    }
                    fontSize={'32px'}
                    fontWeight={600}>
                    {speechData ? getTotalScore(speechData?.total_score) : '--'}
                  </Text>
                )}
              />
              {speechData === null && (
                <Text fontSize={'13px'} color={'#FFCD00'}>
                  Bạn nói chậm lại 1 xíu nha!
                </Text>
              )}
              <Flex gap={'8px'} flexDirection={'column'} alignItems={'center'}>
                <Text color={''} fontSize={'24px'} fontWeight={600}>
                  {speechData?.result
                    ? speechData?.result.map((e: any, index: any) => {
                        return (
                          <Fragment key={index}>
                            <span>
                              {e.letters.map((i: any, index: any) => {
                                return (
                                  <Text
                                    as={'span'}
                                    key={index}
                                    color={getColorSpeechCheck(i.score)}>
                                    {i.letter}
                                  </Text>
                                )
                              })}
                            </span>{' '}
                          </Fragment>
                        )
                      })
                    : currentQuestion?.data.sentence_en}
                </Text>
                <Text color={'#8C8C8C'} fontSize={'16px'}>
                  {currentQuestion?.data.ipa}
                </Text>
                <Text color={'#262626'} fontSize={'16px'}>
                  {currentQuestion?.data.sentence_vi}
                </Text>
              </Flex>
              <Center mt={{base: '30px', md: '80px'}} gap={'40px'}>
                <Center
                  cursor={'pointer'}
                  h={'48px'}
                  w={'48px'}
                  borderRadius={'50%'}
                  bg={'rgba(1, 172, 255, 0.10)'}
                  _hover={{bg: 'rgba(1, 172, 255, 0.20)'}}
                  onClick={() => handlePlayAudio(currentQuestion?.data.audio)}>
                  <Image h={'24px'} w={'24px'} src={VolumeIcon} />
                </Center>
                <GlobalMic3
                  isDisabled={false}
                  handleStartRecording={handleStartRecording}
                  handleRecordingComplete={getSpeechCheck}
                />
                <Box h={'48px'} w={'48px'}></Box>
              </Center>
            </Flex>
          </Box>
        </Box>
      </Flex>
    </Box>
  )
}

export default Exercise2
